<div class="modal-header">
    <h4 class="modal-title">Add New {{headerLabel}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div class="row mb-3">
    <div class="col-3 mogo-label text-start mogo-bold">
      {{headerLabel}}
    </div>
    <div class="col-9">
      <div class="row">
        <div class="col-12 mogo-label text-start mogo-bold">
          {{addressName}}
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          {{addressDetails}}
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="formGroup">
    <div class="row mb-3">
      <div class="col-3 mogo-label text-start mogo-bold">
      {{headerLabel}} Name
      </div>
      <div class="col-9">
        <input type="text" class="form-control" formControlName="newLocationName" placeholder="Enter a name for this location (e.g. 'Warehouse Back Entrance')" />
      </div>
    </div>
    <div class="row mb-2">

      <div class="col-2 mogo-label text-start mogo-bold">
        Latitude
      </div>
      <div class="col-4">
        {{ getLatitude() }}
      </div>

      <div class="col-2 mogo-label text-start mogo-bold">
        Longitude
      </div>
      <div class="col-4">
        {{ getLongitude() }}
      </div>
    </div>
  </form>
  <div class="row">
    @if(invalidCoordinates){
      <div class="col-12 alert alert-danger" role="alert">
        The coordinates entered are invalid. Please enter valid latitude and longitude values.
      </div>
    } @else{
      <div class="col-12">
        <div #deliveryLocationMap id="delivery-location-map" style="height: 64vh"></div>
      </div>
    }
  </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="saveLocation()" [disabled]="locationStateInvalid()">Save</button>
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Close</button>
</div>
